module.exports = __webpack_public_path__ + "static/media/eagle.0bdef80a.svg";